import deductionPlan from "./deductionPlan.component";
import deductionPlanUrls from "./deductionPlan.urls";
import DeductionPlanTransforms from "./deductionPlan.transforms";

const deductionPlanModule = angular
  .module("app.components.deductionPlan", [])
  .component("deductionPlanPage", deductionPlan)
  .service("DeductionPlanTransforms", DeductionPlanTransforms)
  .config(deductionPlanUrls);

export default deductionPlanModule;



// WEBPACK FOOTER //
// ./src/pages/deductionPlan/deductionPlan.module.js